<template>
  <div class="uk-padding-remove uk-margin-remove" style="min-height: 50px">
    <p class="error-message uk-margin-remove" :style="isVisible">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoginMessage',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    isVisible() {
      return this.active ? 'display: inline-block;' : 'display: none;'
    }
  }
}
</script>
<style>
.error-message {
  color: #dd1319;
  font-size: 1rem;
}
</style>
